import Persistable from "../../../storage/persistable";

export default class PlayerContext extends Persistable {
    constructor(teamId, playerId) {
        super();

        this.teamId = teamId;
        this.playerId = playerId;
    }
}
